export default function adj(n: number): number {
  return +n.toFixed(1);
}
